import { gql } from '@apollo/client';

import { SUGGEST_CHANGE_FIELDS } from './suggestChange.fragment';

export * from './suggestedChangeCreate.mutation.generated';

export const SUGGESTED_CHANGE_CREATE = gql`
  ${SUGGEST_CHANGE_FIELDS}
  mutation suggestedChangeCreate($escrowId: ID!, $suggestedChangeParams: SuggestedChangeParams!) {
    suggestedChangeCreate(input: { escrowId: $escrowId, suggestedChangeParams: $suggestedChangeParams }) {
      success
      errors
      suggestedChange {
        ...SuggestChangeFields
      }
    }
  }
`;
